import type React from "react";

import { Button, Modal } from "@alpacahq/ui/old";

import { Icon } from "~/v2/components/AssetIcon/AssetIcon";

export interface WhitelistDetailsModalDetails {
  chainLabel: string;
  chainIconKey: string;
  assetLabel: string;
  assetIconKey: string;
  address: string;
  selfHosted: "Yes" | "No" | null;
  walletOwner: string | null;
  custodian: string | null;
}

export interface WhitelistDetailsModalProps {
  details: WhitelistDetailsModalDetails | null;
  onClose: () => void;
  onDelete: () => void;
  isDeleteLoading: boolean;
}

const Row = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <div className="flex w-full items-center justify-between gap-4">
    <span className="text-gray-700 text-sm">{label}</span>
    <div className="flex min-w-0 items-center text-right font-medium text-gray-950 text-sm">
      {children}
    </div>
  </div>
);

const DetailsCard = ({
  details,
}: {
  details: WhitelistDetailsModalDetails;
}) => (
  <div className="flex flex-col gap-2 rounded bg-gray-50 p-2">
    <Row label="Chain">
      <span className="inline-flex items-center justify-end gap-2">
        <Icon name={details.chainIconKey} className="h-5 w-5" />
        <span>{details.chainLabel}</span>
      </span>
    </Row>
    <Row label="Asset">
      <span className="inline-flex items-center justify-end gap-2">
        <Icon name={details.assetIconKey} className="h-5 w-5" />
        <span>{details.assetLabel}</span>
      </span>
    </Row>
    <Row label="Address">
      <span className="break-all font-mono text-xs">{details.address}</span>
    </Row>
    {details.selfHosted !== null && (
      <Row label="Self hosted wallet">{details.selfHosted}</Row>
    )}
    {details.walletOwner && (
      <Row label="Wallet Owner">{details.walletOwner}</Row>
    )}
    {details.custodian && (
      <Row label="Custodian or Exchange">{details.custodian}</Row>
    )}
  </div>
);

export const WhitelistDetailsModal = ({
  details,
  onClose,
  onDelete,
  isDeleteLoading,
}: WhitelistDetailsModalProps) => (
  <Modal
    size="md"
    title="Whitelist Details"
    isOpen={details !== null}
    onClose={onClose}
    controls={
      <div className="flex items-center justify-end gap-4">
        <Button
          className="border-red-500 text-red-500 hover:border-red-600 active:border-red-700"
          variant="v2/stroke"
          onClick={onDelete}
          loading={isDeleteLoading}
        >
          Delete Address
        </Button>
        <Button variant="v2/filled" onClick={onClose}>
          Done
        </Button>
      </div>
    }
  >
    {details && <DetailsCard details={details} />}
  </Modal>
);
